import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CommonSelect } from "../common";
import { TroubleshootRounded } from "@mui/icons-material";
import {
  numberFormatter,
} from "../../utils/generalFunctions";

//inline styles
const InlineStyles = {
  TableHeader: {
    backgroundColor: "#262671",
    color: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
    height: "50px",
  },
  TableCells: {
    color: "black",
    fontSize: "12px",
    height: "44px",
    padding: "0px",
  },
  TableBodyRows: {
    border: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "15px",
    verticalAlign: "top",
  },
  TableBodyRowCells: {
    height: "20px",
    padding: "0px",
  },
  PaymentReceiveDate: {
    width: "100px",
    height: "33px",
    padding: "0px",
  },
  BrokerBranchTableCell: {
    height: "20px",
    padding: "3px",
    // width:"150px"
  },
  ReceivableAmountTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentCurrencyCodeTableCell: {
    height: "20px",
    padding: "3px",
  },
  BankExchangeRateTableCell: {
    height: "20px",
    padding: "3px",
  },
  BankExchangeChargesTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentReferenceTableCell: {
    height: "20px",
    padding: "3px",
  },
  PaymentReference: {
    position: "relative",
    width: "83px",
    height: "32",
  },
  PaymentCurrency: {
    position: "relative",
    width: "80px",
    height: "32",
  },
  MoreVertIconStyle: {
    color: "FF5A01",
    background: "transparent",
    cursor: "pointer",
    transform: "rotate(90deg)",
  },
  BankChargesTableCell: {
    height: "20px",
    padding: "3px",
  },
};

export const AddUpload = ({
  dropdownValuesCurreny,
  selectAll,
  handleSelectAll,
  handleInputChange,
  handleCheckboxChange,
  handleBlur,
  rows,
  validationStatus,
  handlePaymentReferenceOpenDialog,
  selectedRows,
}) => {
  return (
    <Table>
      <TableHead style={InlineStyles.TableHeader}>
        <TableRow style={{ backgroundColor: "#FFC000" }}>
          <TableCell style={InlineStyles.TableCells}>
            <Checkbox
              checked={selectAll}
              onChange={(e) => handleSelectAll(e)}
              style={{ color: "black" }}
            />
          </TableCell>
          <TableCell className="TableCell">Payment Date</TableCell>
          <TableCell className="TableCell">Bank Txn Id</TableCell>
          <TableCell className="TableCell">
            Payment <br />
            Reference
          </TableCell>
          <TableCell className="TableCell">
            Original <br />
            Currency
          </TableCell>
          <TableCell className="TableCell">
            Payment <br />
            Amount
          </TableCell>
          <TableCell className="TableCell">Broker Name</TableCell>
          <TableCell className="TableCell">Assignment</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index} style={InlineStyles.TableBodyRows}>
            <TableCell sx={InlineStyles.TableBodyRowCells}>
              <Checkbox
                checked={
                  selectAll
                    ? selectAll
                    : selectedRows.findIndex((item) => item?.id === row.id) !==
                      -1
                }
                onChange={(e) => handleCheckboxChange(row, e.target.checked)}
              />
            </TableCell>
            <TableCell sx={{ padding: "3px" }}>
              <input
                type="date"
                value={
                  row.Payment_Receive_Date
                    ? row.Payment_Receive_Date.substring(0, 10)
                    : ""
                }
                onChange={(e) =>
                  handleInputChange(
                    index,
                    "Payment_Receive_Date",
                    e.target.value
                  )
                }
                style={InlineStyles.PaymentReceiveDate}
                placeholder="Enter Details Here"
                disabled={true}
              />
              <br />
              {validationStatus[index]?.Payment_Receive_Date && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Receive_Date}
                </span>
              )}
            </TableCell>
            <TableCell>
              <TextField
                value={row.Bank_Transaction_Id}
                sx={{ width: "130px" }}
                size="small"
                type="text" // Set the input type to "text" to handle both negative and positive numbers
                disabled={true}
              />
            </TableCell>
            <TableCell sx={InlineStyles.PaymentReferenceTableCell}>
              <TextField
                value={row.Payment_Reference}
                onChange={(e) =>
                  handleInputChange(index, "Payment_Reference", e.target.value)
                }
                sx={InlineStyles.PaymentReference}
                size="small"
                placeholder="Enter Details Here"
                disabled={true}
                InputProps={{
                  endAdornment: (
                    <MoreVertIcon
                      onClick={() =>
                        handlePaymentReferenceOpenDialog(
                          index,
                          row.Payment_Reference
                        )
                      }
                      style={InlineStyles.MoreVertIconStyle}
                    />
                  ),
                }}
              />
              <br />
              {validationStatus[index]?.Payment_Reference && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Reference}
                </span>
              )}
            </TableCell>
            <TableCell sx={InlineStyles.PaymentCurrencyCodeTableCell}>
              <CommonSelect
                disabled={true}
                handleChange={(event, value, reason) =>
                  handleInputChange(
                    index,
                    "Payment_Currency_Code",
                    value,
                    reason,
                    event
                  )
                }
                customStyles={InlineStyles.PaymentCurrency}
                name="payment currncy code"
                // Map through your list of dropdown values
                options={dropdownValuesCurreny?.map(
                  (option) => option.currency_code
                )}
                placeholder="Select Currency"
                value={row.Payment_Currency_Code}
              />
              {validationStatus[index]?.Payment_Currency_Code && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Currency_Code}
                </span>
              )}
            </TableCell>
            <TableCell sx={InlineStyles.ReceivableAmountTableCell}>
              <TextField
                onChange={(e) =>
                  handleInputChange(index, "Receivable_Amount", e.target.value)
                }
                value={numberFormatter(row.Receivable_Amount)}
                onBlur={(e) =>
                  handleBlur(index, "Receivable_Amount", e.target.value)
                }
                sx={{ width: "105px" }}
                size="small"
                type="text" // Set the input type to "text" to handle both negative and positive numbers
                InputProps={{
                  inputProps: {
                    onInput: (e) => {
                      e.preventDefault();
                      const value = e.target.value;
                      const regex = /^-?\d*\.?\d{0,2}$/; // Updated regular expression for numeric input with up to 2 decimal places and negative numbers
                      if (regex.test(value) || value === "" || value === "-") {
                        handleInputChange(index, "Receivable_Amount", value);
                      }
                    },
                  },
                }}
                disabled={true}
                className="right-align"
              />
              <br />
              {validationStatus[index]?.Receivable_Amount && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Receivable_Amount}
                </span>
              )}
            </TableCell>
            <TableCell sx={InlineStyles.BrokerBranchTableCell}>
              <TextField
                onChange={(e) =>
                  handleInputChange(index, "Broker", e.target.value)
                }
                value={row.Broker}
                onBlur={(e) => handleBlur(index, "Broker", e.target.value)}
                sx={{ width: "100px" }}
                size="small"
                type="text" // Set the input type to "text" to handle both negative and positive numbers
                InputProps={{
                  inputProps: {
                    onInput: (e) => {
                      e.preventDefault();
                      const value = e.target.value;
                      const regex = /^-?\d*\.?\d{0,2}$/; // Updated regular expression for numeric input with up to 2 decimal places and negative numbers
                      if (regex.test(value) || value === "" || value === "-") {
                        handleInputChange(index, "BrokerName", value);
                      }
                    },
                  },
                }}
                disabled={true}
              />
              {validationStatus[index]?.Broker && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Broker}
                </span>
              )}
            </TableCell>
            <TableCell sx={InlineStyles.PaymentCurrencyCodeTableCell}>
              <CommonSelect
                disabled={TroubleshootRounded}
                handleChange={(event, value, reason) =>
                  handleInputChange(index, "dsds", value, reason, event)
                }
                name="Assigned user"
                // Map through your list of dropdown values
                options={dropdownValuesCurreny?.map(
                  (option) => option.currency_code
                )}
                placeholder="Select Assignee"
                value={row?.Assigned_Users[0]?.user_name}
              />
              {validationStatus[index]?.Payment_Currency_Code && (
                <span style={{ color: "red" }}>
                  {validationStatus[index]?.Payment_Currency_Code}
                </span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
